import { buildRouteTree } from "utils/routeUtils";

export const routes = buildRouteTree({
	home: null,
	termsOfService: null,
	info: null,
	contactUs: null,
	tournaments: null,
	promotions: null
});
